import { dateLong } from './date'

export default {
  dateLong,
}
